import React from 'react'
import 'regenerator-runtime/runtime'
import Policy from '../routes/Policy'
import Head from 'next/head'

const Routes = () => {
  return (
    <>
      <Head>
        <title>Privacy Policy - DecorMatters</title>
        <meta
          name="description"
          content="Thank you for choosing to be part of our community at DecorMatters, Inc. (“company”, “we”, “us”, or “our”). We are committed to protecting your personal information and your right to privacy."
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:site"
          content={`https://www.decormatters.com/policy`}
        />
        <meta name="twitter:title" content="Privacy Policy - DecorMatters" />
        <meta name="twitter:site" content="@decormattersapp" />
        <meta
          property="og:url"
          content={`https://www.decormatters.com/policy`}
        />
        <meta property="og:title" content="Privacy Policy - DecorMatters" />
        <meta
          property="og:description"
          content="Thank you for choosing to be part of our community at DecorMatters, Inc. (“company”, “we”, “us”, or “our”). We are committed to protecting your personal information and your right to privacy."
        />
      </Head>
      <Policy />
    </>
  )
}

export default Routes
